/**
 * ErrorMessage — unified error display component.
 *
 * Renders nothing when `message` is falsy, so callers can write:
 *   <ErrorMessage message={error} />
 * without wrapping it in a conditional.
 *
 * Recoverable errors (release review 2026-09-17): pass `onRetry` to render a
 * "Retry" button inside the alert, and/or `actions` — `[{label, onClick}]` —
 * for EXPLICIT "proceed without …" choices. An error state must never be
 * mistaken for an empty state, and never silently degrade: the archer
 * either retries or opts out in so many words.
 */
export function ErrorMessage({ message, className = "", style, onRetry, actions }) {
  if (!message) return null;
  const extra = Array.isArray(actions) ? actions.filter((a) => a && a.label) : [];
  const hasActions = typeof onRetry === "function" || extra.length > 0;
  return (
    <div
      className={`error-message${hasActions ? " error-message--actions" : ""}${className ? " " + className : ""}`}
      role="alert"
      style={style}
    >
      {hasActions ? <span className="error-message-text">{message}</span> : message}
      {hasActions && (
        <span className="error-message-btns">
          {typeof onRetry === "function" && (
            <button type="button" className="btn ghost error-message-btn" onClick={onRetry}>
              Retry
            </button>
          )}
          {extra.map((a) => (
            <button
              key={a.label}
              type="button"
              className="btn ghost error-message-btn"
              onClick={a.onClick}
            >
              {a.label}
            </button>
          ))}
        </span>
      )}
    </div>
  );
}
